import PropTypes from 'prop-types';
import React from 'react';
import FormGroup from 'react-bootstrap/FormGroup';
import FormLabel from 'react-bootstrap/FormLabel';
import ReactDatePicker from 'react-date-picker';

import { dateOr } from '../../utils/format-date';
import FieldError from '../field-error';

export const DatePicker = (props) => {
    //@TODO Bad practice - this will create onChange function on every render
    // - Not sure of a better way to do this as react-date-picker doesn't return id... May need to be a smart component
    const onChange = (date) =>
        props.onChange({
            target: {
                id: props.id,
                value: date ? date.toJSON() : '',
            },
        });
    // react-date-picker does not expose its inner inputs, so invalid state
    // is styling + adjacent message only (no aria-invalid on the control)
    const errorId = props.id ? `${props.id}-error` : null;

    return (
        <FormGroup>
            <FormLabel>{props.label}</FormLabel>
            <ReactDatePicker
                {...(props.error && { className: 'is-invalid' })}
                onChange={onChange}
                value={dateOr(props.value)}
            />
            <FieldError id={errorId} error={props.error} />
        </FormGroup>
    );
};

DatePicker.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    error: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
};
